import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { initializeApp } from "firebase/app";
import { environment } from "src/environments/environment";
import { getAuth } from "firebase/auth";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor() { }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let authReq = req;
    // const app = initializeApp(environment.firebase);
    // const auth = getAuth(app);

    // if (auth.currentUser?.getIdToken()) {
    //   auth.currentUser?.getIdToken().then(
    //     token => {
    //       authReq = req.clone({
    //         setHeaders: {
    //           Authorization: token,
    //         },
    //       });
    //     }
    //   );
    //   return next.handle(authReq);
    // } else {
      return next.handle(authReq);
    // }
  }
}

export const authInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
];
